import { render } from "./PdfPurchase.vue?vue&type=template&id=68cfe927&scoped=true"
import script from "./PdfPurchase.vue?vue&type=script&lang=js"
export * from "./PdfPurchase.vue?vue&type=script&lang=js"

import "./PdfPurchase.vue?vue&type=style&index=0&id=68cfe927&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cfe927"]])

export default __exports__